<template>
  <div>
    <CRow>
      <CCol col="12" md="12" lg="12">
        <h4><strong>Data Asuransi</strong></h4>
        <hr />
      </CCol>
    </CRow>

    <CRow>
      <CCol col="12" md="12" lg="12">
        <b-button variant="primary" v-b-modal.modal-input-asuransi><CIcon name="cil-plus" /> Tambah Data</b-button>
      </CCol>
    </CRow>

    <CRow class="mt-3">
      <CCol col="12" md="12" lg="12">
        <CDataTable :items="items" :fields="fields" responsive sorter hover show-empty :loading="tableBusy">
          <template #actions="{ item }">
            <td>
              <b-button variant="warning" class="mr-1" v-c-tooltip.hover.click="$store.state.table.tooltipEdit" v-b-modal.modal-edit-asuransi @click="dataAsuransi = item">
                <CIcon name="cil-pencil" />
              </b-button>
              <b-button variant="danger" class="mr-1" v-c-tooltip.hover.click="$store.state.table.tooltipHapus" v-b-modal.modal-delete-asuransi @click="dataAsuransi = item">
                <CIcon name="cil-trash" />
              </b-button>
            </td>
          </template>
        </CDataTable>
      </CCol>
    </CRow>

    <modal-input :asuransi="asuransi" :data="data" @alertFromChild="triggerAlert($event)" />
    <modal-edit :dataAsuransi="dataAsuransi" :data="data" @alertFromChild="triggerAlert($event)" />
    <modal-delete :dataAsuransi="dataAsuransi" :data="data" @alertFromChild="triggerAlert($event)" />
  </div>
</template>
<script>
import modalInput from "./modalInput.vue";
import modalEdit from "./modalEdit.vue";
import modalDelete from "./modalDelete.vue";

export default {
  components: {
    modalInput,
    modalEdit,
    modalDelete,
  },
  name: "modalAsuransiProfil",
  props: ["data", "asuransi", "activeTab"],
  data() {
    return {
      dataAsuransi: "",
      items: [],
      fields: [
        { key: "no", label: "No", sortDirection: "desc", _classes: "table-number text-center", sorter: true },
        { key: "namaAsuransi", label: "Asuransi", sortDirection: "desc", _style: "width: 45%;", _classes: "text-left", sorter: true },
        { key: "potonganAsuransi", label: "Potongan", sortDirection: "desc", _style: "width: 20%;", _classes: "text-left", sorter: true },
        { key: "nomorAsuransi", label: "Nomor Asuransi", sortDirection: "desc", _style: "width: 20%;", _classes: "text-left", sorter: true },
        { key: "actions", label: "Actions", _classes: "table-option-3 text-center", _style: "width: 15%;" },
      ],
      tableBusy: false,
    };
  },
  watch: {
    "data.dataKaryawanId"(newVar, oldVar) {
      if (newVar != oldVar) {
        this.getDataAsuransi();
      }
    },
    activeTab(newVal) {
      if (newVal === 1) {
        this.getDataAsuransi();
      }
    },
  },
  mounted() {
    // this.getDataAsuransi();
  },
  methods: {
    async getDataAsuransi() {
      let vm = this;
      if (!vm.data.dataKaryawanId) return;

      let id = vm.data.dataKaryawanId;
      let listAsuransi = await vm.$axios.get("poolPotonganAsuransi/listByDataKaryawanId/" + id);
      vm.items = listAsuransi.data.data;

      for (let i = 0; i < vm.items.length; i++) {
        vm.items[i].no = i + 1;
      }
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDataAsuransi();
    },
  },
};
</script>
